if (!customElements.get('simple-slider')) {
  class SimpleSlider extends HTMLElement {
    constructor() {
      super();

      this.sliderList = this.querySelector('[data-list]');
      this.left = this.querySelector('[data-left]');
      this.right = this.querySelector('[data-right]');
      this.controls = this.querySelector('[data-controls]');

      this.slide = this.sliderList?.children[0] || null;
      this.isMouseDown = false;
      this.startX = 0;
      this.dragged = false;
      this.scrollRaf = null;
      this.onScroll = this.handleScroll.bind(this);

      this.setupEventListeners();
      this.sliderList.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.updateFromScroll();
    }

    setupEventListeners() {
      this.left?.addEventListener('click', () => this.scrollLeft());
      this.right?.addEventListener('click', () => this.scrollRight());

      if (window.innerWidth >= 750) {
        this.sliderList.addEventListener('mousedown', this.onMouseDown.bind(this));
        this.sliderList.addEventListener('mousemove', this.onMouseMove.bind(this));
        this.sliderList.addEventListener('mouseup', this.onMouseUp.bind(this));
        this.sliderList.addEventListener('mouseleave', this.onMouseUp.bind(this));

        // Prevent link navigation on drag
        this.sliderList.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', (event) => {
            if (this.dragged) event.preventDefault();
          });
        });
      }
    }

    onMouseDown(event) {
      this.isMouseDown = true;
      this.startX = event.pageX;
      this.startScroll = this.sliderList.scrollLeft;
      this.dragged = false;
      this.sliderList.style.cursor = 'grabbing';
      // smooth scrolling fights a 1:1 drag, so turn it off for the duration
      this.sliderList.style.scrollBehavior = 'auto';
    }

    onMouseMove(event) {
      if (!this.isMouseDown) return;
      event.preventDefault();

      const distance = event.pageX - this.startX;
      if (Math.abs(distance) > 5) this.dragged = true;

      this.sliderList.scrollLeft = this.startScroll - distance;
    }

    onMouseUp() {
      if (!this.isMouseDown) return;
      this.isMouseDown = false;
      this.sliderList.style.cursor = 'grab';
      this.sliderList.style.scrollBehavior = '';
    }

    scrollLeft() {
      this.sliderList.scrollLeft -= this.slide.clientWidth;
    }

    scrollRight() {
      this.sliderList.scrollLeft += this.slide.clientWidth;
    }

    handleScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        this.updateFromScroll();
      });
    }

    updateFromScroll() {
      const list = this.sliderList;
      const maxScroll = list.scrollWidth - list.clientWidth;

      // Nothing to scroll to: controls would be dead buttons.
      // Sub-pixel layout rounding can leave a fraction of overflow, so allow 1px.
      this.controls?.toggleAttribute('data-hidden', maxScroll <= 1);

      const atStart = list.scrollLeft <= 1;
      const atEnd = list.scrollLeft >= maxScroll - 1;
      this.left?.toggleAttribute('data-active', !atStart);
      this.right?.toggleAttribute('data-active', !atEnd);
    }
  }

  customElements.define('simple-slider', SimpleSlider);
}
